export const iconFontAwesomeHandsHandLizard = (
	<i className="fa-solid fa-hand-lizard"></i>
);
